export default {
    contact: {
        getOne: ['GET', 'contact/{contactId}'],
    },
};
